import { Box, Button, IconButton, Modal, TextField } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createResource, deleteResource, getResources, selectResources } from './state/resourcesSlice'
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons'
import { userProfile } from '@views/profile/state/profileSlice'
import { Role } from '@types'

const Resources: React.FC = () => {
  const dispatch = useDispatch()
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [resourceTitle, setResourceTitle] = useState('')
  const [resourceLink, setResourceLink] = useState('')
  const [resourceDescription, setResourceDescription] = useState('')
  useEffect(() => {
    dispatch(getResources())
  }, [])
  const { role } = useSelector(userProfile)
  const resources = useSelector(selectResources)
  return (
    <>
      <Box padding="80px 10px 10px 10px">
        <h2>Recursos:</h2>
        <Box display="flex" flexWrap="wrap">
          {resources?.map(resource => (
            <Box
              width="280px"
              borderRadius="0.7rem"
              display="flex"
              flexDirection="column"
              justifyContent="left"
              margin="5px"
              padding="1em"
              border="solid 1px #c9c9c9"
              className="hover-highlight"
              key={resource.name}
              onClick={e => {
                if (e.currentTarget.nodeName !== 'path') window.open(resource.link, '_blank')
              }}
            >
              <Box fontSize="16px" fontWeight="bold">
                {resource.name}
              </Box>
              <div>{resource.description}</div>
              {role === Role.admin ? (
                <Box display="flex" justifyContent="flex-end">
                  <IconButton
                    style={{
                      background: '#ff6900',
                      color: '#fff',
                      width: '8px',
                      height: '10px',
                      margin: '5px'
                    }}
                    onClick={e => {
                      e.stopPropagation()
                      if (
                        resource._id &&
                        confirm(`Seguro que desea eliminar el recurso ${resource.name}: ${resource.link} ?`)
                      ) {
                        dispatch(deleteResource(resource._id))
                      }
                    }}
                  >
                    <DeleteIcon style={{ width: '15px' }} />
                  </IconButton>
                </Box>
              ) : null}
            </Box>
          ))}
        </Box>
        {role === Role.admin ? (
          <Box position="fixed" bottom="20px" right="20px">
            <IconButton
              style={{
                background: '#ff6900',
                color: '#fff',
                width: '2em',
                height: '2em'
              }}
              onClick={() => setIsOpenModal(true)}
            >
              <AddIcon style={{ width: '1.5em' }} />
            </IconButton>
          </Box>
        ) : null}
      </Box>
      <Modal
        open={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        onSubmit={event => {
          event.preventDefault()
          dispatch(
            createResource({
              name: resourceTitle,
              description: resourceDescription,
              link: resourceLink
            })
          )
          setResourceDescription('')
          setResourceTitle('')
          setResourceLink('')
          setIsOpenModal(false)
        }}
      >
        <form>
          <Box bgcolor="white" display="flex" flexDirection="column" padding="10px" borderRadius="0.5rem">
            <TextField
              label="Nombre"
              variant="outlined"
              margin="normal"
              value={resourceTitle}
              required
              // disabled={isLoading}
              onChange={e => {
                setResourceTitle(e.target.value)
              }}
            />
            <TextField
              label="Link"
              variant="outlined"
              margin="normal"
              value={resourceLink}
              required
              // disabled={isLoading}
              onChange={e => {
                setResourceLink(e.target.value)
              }}
            />
            <TextField
              label="Descripcion"
              variant="outlined"
              margin="normal"
              value={resourceDescription}
              // disabled={isLoading}
              onChange={e => {
                setResourceDescription(e.target.value)
              }}
            />
            <Button type="submit" variant="contained" color="primary">
              GUARDAR
            </Button>
          </Box>
        </form>
      </Modal>
    </>
  )
}

export default Resources
